import React, { useState } from 'react';
import { FaEdit, FaSave } from 'react-icons/fa';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../App';

const ProfileFunctions = ({ userData, setUserData }) => {
  const [isEditingPic, setIsEditingPic] = useState(false);
  const [newProfilePicUrl, setNewProfilePicUrl] = useState('');

  const handleUpdateProfilePic = async () => {
    if (!newProfilePicUrl) return;

    try {
      if (!userData.userId) {
        throw new Error('User ID is not defined');
      }

      const userDocRef = doc(db, 'users', userData.userId);
      await updateDoc(userDocRef, {
        profilePicture: newProfilePicUrl,
      });
      await setUserData();
      setIsEditingPic(false);
      setNewProfilePicUrl('');
    } catch (error) {
      console.error('Error updating profile picture:', error);
      alert('Failed to update profile picture. Please try again.');
    }
  };

  return (
    <div className="profile-picture-edit-container">
      <button onClick={() => setIsEditingPic(!isEditingPic)} className="edit-picture-btn">
        <FaEdit />
      </button>
      {isEditingPic && (
        <div className="update-profile-pic">
          <input 
            type="text" 
            placeholder="Enter Image URL" 
            value={newProfilePicUrl}
            onChange={(e) => setNewProfilePicUrl(e.target.value)}
          />
          <button className="save-icon" onClick={handleUpdateProfilePic}>
            <FaSave />
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileFunctions;
